import React, { useContext, useCallback } from 'react';
import cloneDeep from 'lodash/cloneDeep';

import { ShareAndRestrictDialogController } from '@confluence/share-and-restrict-dialog/entry-points/ShareAndRestrictDialogController.ts';
import type { ContentType } from '@confluence/share-and-restrict-dialog/entry-points/ShareRestrictAndCopyCoordinator.tsx';

import { PublishModalContext } from './PublishModalContext.tsx';

export type ShareAndRestrictDialogInPublishModalProps = {
	onClose: () => void;
	contentId: string;
	contentType: ContentType;
	isUnpublishedDraft: boolean;
};

export const ShareAndRestrictDialogInPublishModal = ({
	onClose,
	contentId,
	contentType,
	isUnpublishedDraft,
}: ShareAndRestrictDialogInPublishModalProps) => {
	const {
		restrictionsObj,
		setRestrictionsObj,
		setGqlRestrictionsInput,
		hasModifiedRestrictions,
		hasScheduledRestrictions,
	} = useContext(PublishModalContext);

	// Clean up setRestrictionsDeepCopy when use_graphql_to_publish_pages_and_blogs is cleaned up
	const setRestrictionsDeepCopy = useCallback(
		(newVal) => {
			const clone = cloneDeep(newVal);
			setRestrictionsObj(clone);
		},
		[setRestrictionsObj],
	);

	const setGqlRestrictionsInputCallback = useCallback(
		(newVal) => {
			const clone = cloneDeep(newVal);
			setGqlRestrictionsInput(clone);
		},
		[setGqlRestrictionsInput],
	);

	const preloadRestrictions =
		hasModifiedRestrictions || hasScheduledRestrictions ? restrictionsObj : undefined;

	return (
		<ShareAndRestrictDialogController
			contentId={contentId}
			contentType={contentType}
			allowRestrictions
			pageModes="view"
			refetchButtonData={() => {}}
			onClose={onClose}
			publishModalRestrictions={preloadRestrictions}
			pushPublishModalRestrictions={setRestrictionsDeepCopy}
			pushPublishModalGqlRestrictionsInput={setGqlRestrictionsInputCallback}
			isUnpublishedDraft={isUnpublishedDraft}
		/>
	);
};
